import React from 'react'
import styled, { withTheme } from 'styled-components'
import Header from '../Header'
import totalCostsSum from '../../../../calculations/totalCosts/sum'
import Chart from './Chart'

const Container = styled.div`
  padding: 30px 0 60px;
  border-top: ${props => props.theme.borders.grey6};
  border-bottom: ${props => props.theme.borders.grey6};
`

export default withTheme(({ form, theme }) => (
  <Container>
    <Header value={totalCostsSum(form)}>
      Total costs of raising a child:
    </Header>
    <Chart form={form} />
  </Container>
))
